import './rxjs-extensions';

import { NgModule, ModuleWithProviders } from '@angular/core';
import { FormsModule }  from '@angular/forms';
import { CommonModule } from '@angular/common';

import { TileComponent } from './tile.component';
import { TileRoutingModule } from './tile.routing.module';
import { ReactiveFormsModule } from '@angular/forms';

import { GenericdatasetService } from '../../services/genericdataset/genericdataset.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TileRoutingModule,
  ],
  exports: [
    TileComponent,
  ],
  declarations: [
    TileComponent
  ],
  providers: [
    GenericdatasetService
  ],
})
export class TileModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: TileModule
        };
    }
}
